export default __webpack_public_path__ + "static/media/grade-graph.dc81683d.png";